export default function isEmpty(value) {
  return (value === '');
}
